import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const LOGO = "/assets/logo.png";

export default function LegalLayout({ title, updated, children }) {
  return (
    <div className="min-h-screen bg-[#FFF9F2] text-[#232323]">
      {/* Header */}
      <header className="border-b border-[#EFE3D5]">
        <div className="max-w-4xl mx-auto px-6 h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="legal-home-link">
            <img src={LOGO} alt="Social Media Combo logo" className="w-8 h-8 object-contain" />
            <span className="font-serif-display text-base sm:text-lg tracking-[0.2em] font-semibold">
              SOCIAL MEDIA COMBO<span className="text-[#F59E0B]">.</span>
            </span>
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-[#666666] hover:text-[#F59E0B] transition-colors"
            data-testid="legal-back-link"
          >
            <ArrowLeft className="w-4 h-4" /> Back to store
          </Link>
        </div>
      </header>

      {/* Body */}
      <main className="max-w-3xl mx-auto px-6 py-16 md:py-24">
        <p className="text-sm uppercase tracking-[0.25em] text-[#F59E0B]">Legal</p>
        <h1 className="font-serif-display text-4xl sm:text-5xl font-bold mt-4">{title}</h1>
        <p className="mt-4 text-sm text-[#666666]">Last updated: {updated}</p>

        <div className="mt-12 space-y-10 legal-content">{children}</div>
      </main>

      {/* Footer */}
      <footer className="border-t border-[#EFE3D5] py-10">
        <div className="max-w-4xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-[#8A8A8A]">
          <span className="font-serif-display tracking-widest">SOCIAL MEDIA COMBO.</span>
          <div className="flex items-center gap-6">
            <Link to="/blog" className="hover:text-[#F59E0B] transition-colors">Blog</Link>
            <Link to="/privacy" className="hover:text-[#F59E0B] transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:text-[#F59E0B] transition-colors">Terms</Link>
            <span>© {new Date().getFullYear()} socialmediacombo.com</span>
          </div>
        </div>
      </footer>
    </div>
  );
}

export function Section({ heading, children }) {
  return (
    <section>
      <h2 className="font-serif-display text-2xl font-semibold text-[#232323]">{heading}</h2>
      <div className="mt-4 space-y-4 text-[#666666] leading-relaxed text-base">{children}</div>
    </section>
  );
}
